export { default as AreaField } from './AreaField';



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Alignment/AreaField/index.ts